import formDefImport from './form-def';
import countryImport from './country.list';
import imgResizeImport from './img-resize';

export const formDef = formDefImport;
export const country = countryImport;
export const resize = imgResizeImport;
export { resizer } from './img-resize';
